import React from 'react';
import { createIcon } from '@chakra-ui/icons';

const CustomCheckIcon = createIcon({
  displayName: 'CustomCheckIcon',
  viewBox: '0 0 512 512', // matching the image’s grid scale
  path: (
    <>
      {/* Green Circle */}
      {/* <circle cx="256" cy="256" r="256" fill="#2C9A00" /> */}

      {/* White Checkmark */}
      <path
        d="M143 273.5L224.5 355L369 191"
        fill="none"
        stroke="white"
        strokeWidth="48"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export default CustomCheckIcon;
